import { z } from 'zod';

import {
  AsrConfigSchema,
  AudioEnhancementSchema,
  SilenceFillerUtterancesSchema,
  VadConfigSchema,
} from './channel.schema';

export const VoiceChannelUpdateAudioEnhancementSchema = z
  .object({
    audioEnhancement: AudioEnhancementSchema.optional(),
  })
  .describe(
    'Update AI-powered audio enhancement settings (e.g., noise reduction, voice gain) for a voice channel.',
  );

export type VoiceChannelUpdateAudioEnhancementPayload = z.infer<
  typeof VoiceChannelUpdateAudioEnhancementSchema
>;

export const VoiceChannelResetAudioEnhancementSchema = z.object({});

export type VoiceChannelResetAudioEnhancementPayload = z.infer<
  typeof VoiceChannelResetAudioEnhancementSchema
>;

export const VoiceChannelUpdateAsrConfigSchema = z
  .object({
    asrConfig: AsrConfigSchema.optional(),
  })
  .describe(
    'Update automatic speech recognition (ASR) provider and model for a voice channel.',
  );

export type VoiceChannelUpdateAsrConfigPayload = z.infer<
  typeof VoiceChannelUpdateAsrConfigSchema
>;

export const VoiceChannelResetAsrConfigSchema = z.object({});

export type VoiceChannelResetAsrConfigPayload = z.infer<
  typeof VoiceChannelResetAsrConfigSchema
>;

export const VoiceChannelUpdateBargeInConfigSchema = z
  .object({
    enabled: z.boolean().optional(),
    allowedFirstTurn: z.boolean().optional(),
    maxPerCall: z.number().int().nonnegative().optional(),
    minSpeechDurationSeconds: z.number().nonnegative().optional(),
  })
  .describe('Update barge-in configuration for a voice channel.');

export type VoiceChannelUpdateBargeInConfigPayload = z.infer<
  typeof VoiceChannelUpdateBargeInConfigSchema
>;

export const VoiceChannelResetBargeInConfigSchema = z.object({});

export type VoiceChannelResetBargeInConfigPayload = z.infer<
  typeof VoiceChannelResetBargeInConfigSchema
>;

export const VoiceChannelUpdateSilenceFillerUtterancesSchema = z
  .object({
    silenceFillerUtterances: SilenceFillerUtterancesSchema.optional(),
  })
  .describe(
    'Update filler utterances played during silence to prevent dead air (e.g., while waiting for API responses).',
  );

export type VoiceChannelUpdateSilenceFillerUtterancesPayload = z.infer<
  typeof VoiceChannelUpdateSilenceFillerUtterancesSchema
>;

export const VoiceChannelResetSilenceFillerUtterancesSchema = z.object({});

export type VoiceChannelResetSilenceFillerUtterancesPayload = z.infer<
  typeof VoiceChannelResetSilenceFillerUtterancesSchema
>;

export const VoiceChannelUpdateTemperatureSchema = z
  .object({
    temperature: z.number().min(0).max(2),
  })
  .describe('Update the LLM temperature override for a voice channel.');

export type VoiceChannelUpdateTemperaturePayload = z.infer<
  typeof VoiceChannelUpdateTemperatureSchema
>;

export const VoiceChannelResetTemperatureSchema = z.object({});

export type VoiceChannelResetTemperaturePayload = z.infer<
  typeof VoiceChannelResetTemperatureSchema
>;

export const VoiceChannelUpdateVadConfigSchema = z
  .object({
    vadConfig: VadConfigSchema.optional(),
  })
  .describe(
    'Update voice activity detection (VAD) settings that control when a caller is considered done speaking.',
  );

export type VoiceChannelUpdateVadConfigPayload = z.infer<
  typeof VoiceChannelUpdateVadConfigSchema
>;

export const VoiceChannelResetVadConfigSchema = z.object({});

export type VoiceChannelResetVadConfigPayload = z.infer<
  typeof VoiceChannelResetVadConfigSchema
>;
